import { useEffect, useState } from 'react';
import { PerspectiveCamera } from '@react-three/drei';

function CameraMap() {
  const path = window.location.pathname;
  const [pathSede, setPathSede] = useState(null);

  const sede = () => {
    if (path.includes('theme')) {
      setPathSede(path.slice(path.indexOf('theme/') + 6, path.lastIndexOf('/')).replaceAll('%20', ' '));
    }
    return pathSede;
  };

  useEffect(() => {
    sede();
  }, []);
  const perspectiveCamValues = () => {
    if (pathSede === 'Sede Lima Cargo') {
      return (
        <PerspectiveCamera
          makeDefault
          position={[53, -10, -90]}
          fov={25}
          zoom={3.8}
        />
      );
    }
    if (pathSede === 'Sede Mall Plaza') {
      return (
        <PerspectiveCamera
          makeDefault
          position={[90, 10, 5]}
          fov={25}
          zoom={2}
        />
      );
    }
    if (pathSede === 'Sede Crillon') {
      return (
        <PerspectiveCamera
          makeDefault
          position={[-3, -1, 20.2]}
          fov={30}
          zoom={1.3}
        />
      );
    }
    if (pathSede === 'Sede Carabaya') {
      return (
        <PerspectiveCamera
          makeDefault
          position={[100, 40, -70]}
          fov={25}
          zoom={5.8}
        />
      );
    }
    return (
      <PerspectiveCamera
        makeDefault
        position={[20, 40, -50]}
        fov={35}
        zoom={0.9}
      />
    );
  };
  return (
    <>
      {perspectiveCamValues()}
    </>
  );
}
export default CameraMap;
